import React, { useEffect } from "react";

const RequestConsultation = ({ isOpen, onClose }) => {
  // Handle escape key press
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === "Escape" && isOpen) {
        onClose();
      }
    };
    
    document.addEventListener("keydown", handleEscKey);
    return () => document.removeEventListener("keydown", handleEscKey);
  }, [isOpen, onClose]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      {/* Modal Overlay */}
      <div
        className="fixed inset-0 bg-black/70 z-[9998] animate-fadeIn"
        onClick={onClose}
      />

      {/* Modal Container */}
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90vw] max-w-[1000px] h-[85vh] max-h-[750px] bg-white rounded-2xl shadow-2xl z-[9999] overflow-hidden animate-scaleIn">
        
        {/* Header with title and close button */}
        <div className="absolute top-0 left-0 right-0 bg-white border-b border-gray-100 px-6 py-3 z-[10000] flex justify-between items-center">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Schedule a Consultation</h3>
            <p className="text-sm text-gray-500">30 min meeting with our team</p>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-full transition-all duration-200 text-gray-600 hover:text-gray-900 text-xl font-bold cursor-pointer"
            aria-label="Close modal"
          >
            ✕
          </button>
        </div>
        
        {/* Iframe for Cal.com - This is the most reliable method */}
        <iframe
          src="https://cal.com/ayanshtechsolutions/30min?embed=1"
          className="w-full h-full pt-16"
          style={{ minHeight: "100%", border: "none" }}
          title="Cal.com Booking"
          allow="camera; microphone; autoplay"
        />
      </div>

      {/* Animation Styles */}
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        
        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: translate(-50%, -50%) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1);
          }
        }
        
        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out;
        }
        
        .animate-scaleIn {
          animation: scaleIn 0.2s ease-out;
        }
      `}</style>
    </>
  );
};

export default RequestConsultation;